<p>
  <mat-toolbar class="mat-toolbar-height">
    <span>{{'user.verification'|translate}}</span>
    <span class="profil-spacer"></span>
    <button mat-icon-button mat-dialog-close="false">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>
</p>

<form [formGroup]="pwdForm">
  <mat-form-field class="full-width" appearance="outline">
    <mat-label>{{'user.enter_password'|translate}}</mat-label>
    <input matInput formControlName="password" type="password">
    <mat-icon matSuffix>lock_outline</mat-icon>
    <mat-error *ngIf="pwdForm.controls['password'].hasError('required')">{{'form.required_field'|translate}}</mat-error>
    <mat-error *ngIf="pwdForm.controls['password'].hasError('incorrect')">{{'user.incorrect_password'|translate}}</mat-error>
  </mat-form-field>
  

  <mat-dialog-actions>
    <button mat-flat-button color="primary" type="submit" (click)="verifPwd()">{{'form.verify'|translate}}</button>
    <button mat-button mat-dialog-close mat-dialog-close="false">{{'form.cancel'|translate}}</button>
  </mat-dialog-actions>
</form>
